import React from 'react'
import { connect } from 'react-redux'
import api, { apiAction, apiActionWithRoute } from '../../../api'
import { Loading } from '../../../components'

import actions from './actions'

import LabelLevel from './levels'

const LabelLevels = ({ fetchLabelLevels, fetchLocales, locales, cooking, browning }) => {

  const {
    loaded,
  } = actions({ fetchLabelLevels, fetchLocales })

  return loaded ? (
    <div>
      {!(locales || []).length && <div>Please create at least one locale first</div>}
      {locales && browning && (
        <LabelLevel levels={browning} locales={locales} title="Browning" key={`browning_${browning.new}`}/>
      )}
      {locales && cooking && (
        <LabelLevel levels={cooking} locales={locales} title="Cooking" key={`cooking_${cooking.new}`}/>
      )}
    </div>
  ) : <Loading />
}

const mapStateToProps = (state, { entityName }) => ({
  cooking: state.labellevels.cooking,
  browning: state.labellevels.browning,
  locales: state.locales.list,
})

const mapDispatchToProps = (dispatch, { entityName } ) => ({
  fetchLocales: () => dispatch(apiAction(api.getLocales)()),
  fetchLabelLevels: (type, defaultLocale) =>
    dispatch(apiActionWithRoute(api.getDefaultLabelLevels)(type)(null, { quite: true, defaultLocale })),
})

export default connect(mapStateToProps, mapDispatchToProps)(LabelLevels)
